import { render, staticRenderFns } from "./product-detail-dialog.vue?vue&type=template&id=3b7073ac&scoped=true"
import script from "./product-detail-dialog.vue?vue&type=script&lang=js"
export * from "./product-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./product-detail-dialog.vue?vue&type=style&index=0&id=3b7073ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7073ac",
  null
  
)

export default component.exports